import { render, staticRenderFns } from "./UserRecord.vue?vue&type=template&id=22cd9982&scoped=true&"
import script from "./UserRecord.vue?vue&type=script&lang=js&"
export * from "./UserRecord.vue?vue&type=script&lang=js&"
import style0 from "./UserRecord.vue?vue&type=style&index=0&id=22cd9982&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cd9982",
  null
  
)

export default component.exports